import { z } from 'zod';

import { cuidLike, nonEmptyString, paginationInput } from '../zod-common';

export const BID_STATUSES = [
  'ACTIVE',
  'WAITING',
  'WAITING_BIDDER_RESPONSE',
  'WON',
  'OUTDATED',
  'EXPIRED',
  'WITHDRAWN',
  'WITHDRAWN_BY_REQUESTER',
  'ARCHIVED',
] as const;
export type BidStatusValue = (typeof BID_STATUSES)[number];

export const createBidDraftSchema = z.object({
  offerId: cuidLike,
});
export type CreateBidDraftInput = z.infer<typeof createBidDraftSchema>;

export const bidUpdateMetaSchema = z.object({
  bidId: cuidLike,
  message: z.string().trim().max(4_000).optional(),
});
export type BidUpdateMetaInput = z.infer<typeof bidUpdateMetaSchema>;

export const bidByIdSchema = z.object({
  bidId: cuidLike,
});
export type BidByIdInput = z.infer<typeof bidByIdSchema>;

export const listOfferBidsSchema = z.object({
  offerId: cuidLike,
  includeOutdated: z.boolean().optional(),
});
export type ListOfferBidsInput = z.infer<typeof listOfferBidsSchema>;

export const myBidsSchema = paginationInput.extend({
  status: z.enum(BID_STATUSES).optional(),
});
export type MyBidsInput = z.infer<typeof myBidsSchema>;

export const withdrawBidSchema = z.object({
  bidId: cuidLike,
});
export type WithdrawBidInput = z.infer<typeof withdrawBidSchema>;

export const postBidCommentSchema = z.object({
  bidId: cuidLike,
  content: nonEmptyString.max(4_000, 'Max 4000 caractères'),
});
export type PostBidCommentInput = z.infer<typeof postBidCommentSchema>;

export const getBidCommentsSchema = z.object({
  bidId: cuidLike,
});
export type GetBidCommentsInput = z.infer<typeof getBidCommentsSchema>;
